import { useFeatureFlagEnabled } from "posthog-js/react";

export type FeatureFlag = "agent" | "research_tasks_enabled";

export function useFeatureFlag(flag: FeatureFlag): boolean {
  // Demo branch (deploy-mazzouzi-prototype, never merges): always enable agentic
  // and research features for the throwaway demo, bypassing PostHog gating. The
  // flag is still read so the PostHog hook order and exposure stay consistent.
  useFeatureFlagEnabled(flag);
  return true;
}
